<template>
    <section class="h-100 w-100 bg-white rounded">
        <b-row class="m-0 p-0 bg-white h-100 w-100">

            <!-- Configuraciones de la ET -->
            <b-col :md="isShowingForm ? 3 : 5" class="p-2 bg-white">

                <!-- Formulario -->
                <FormToSaveDesign :generatedHtml="generatedHtml" />

            </b-col>

            <!-- Diseñar la ET -->
            <b-col :cols="isShowingForm ? 9 : 12" class="bg-gray-100">

                <!-- Cabecera -->
                <div class="bg-white mt-2 p-2 rounded d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                        <i :class="hasBlockFields ? 'fa fa-lock mx-2 text-info' : 'fa fa-paint-brush mx-2 text-dark'" :style="{ fontSize: '30px' }"></i> 
                        <div class="ml-2">
                            <h4><strong :class="hasBlockFields ? 'text-info' : 'text-dark'">Diseñador de etiquetas</strong></h4>
                            <div class="d-flex align-items-center rounded" :style="{ fontSize: '10px' }" v-if="activeSection">
                                <div class="font-weight-bold" :style="{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '130px' }">
                                    {{ activeSection.baseTitle || 'Sin título' }}
                                </div>
                                <div>
                                    <i class="fa fa-rule mr-1"></i>
                                    {{ activeSection.w / 2 }} cm * {{ activeSection.h / 2 }} cm
                                </div>
                            </div>
                        </div>                                                   
                    </div>   

                    <!-- Acciones -->
                    <div class="d-flex">                         

                        <!-- Permite agregar secciones -->
                        <el-select v-if="!hasBlockFields" v-model="sectionSelected" placeholder="Agregar secciones" :style="{ maxWidth: '200px' }" @change="onHandleAddSection">
                            <el-option-group v-for="group in getAvailableSections" :key="group.label" :label="group.label">
                                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
                            </el-option-group>
                        </el-select>

                        <!-- Permite ver el diseño en tipo real -->
                        <b-button class="ml-2 text-white" :variant="hasBlockFields ? 'info' : 'dark'" @click="onHandleShowPreviewer">
                            <i class="fa fa-desktop"></i>
                        </b-button>
                    </div>
                </div>

                <!-- Barra de diseño -->
                <DesignBar ref="designBarRef" v-if="!hasBlockFields" />

                <!-- Diseñador -->
                <div :style="{ border: 0, height: '100vh' }">

                    <div class="container-draw" :class="{ 'blocked': hasBlockFields }" :style="{ width: '100%', height: '100%' }" @mousemove="handleMouseMove"
                        @mouseleave="hideCross" >

                        <grid-layout :layout.sync="selectedLayout.layout"
                            :col-num="parseFloat(selectedLayout.gridWidthCm - 2 * 0) * 2" :row-height="19" :is-bound="true"
                            :is-draggable="!hasBlockFields" :is-resizable="!hasBlockFields" :vertical-compact="false"
                            :prevent-collision="true" :use-css-transforms="true" :margin="[0, 0]"
                            :style="gridStyle">
                            <grid-item v-for="(item, index) in selectedLayout.layout" :x="item.x" :y="item.y"
                                :id-template="item.code" :w="item.w" :min-w="0.5" :min-h="0.5" :h="item.h"
                                :i="item.i || String(index)" :key="item.id" :style="getStylesToItemGrid(item)">
                                <div @click="onHandleActionToSection(item)" :class="{ 'blocked-movement': hasBlockFields }">
                                    <div v-if="activeSection && activeSection.i === item.i" :style="{
                                        position: 'absolute', left: '2px', top: '2px',
                                        width: '15px', height: '15px', backgroundColor: '#20a8d8', borderRadius: '50%', lineHeight: 'normal', display: 'block', verticalAlign: item.alignItems === 'center' ? 'middle' : (item.alignItems === 'flex-end' ? 'bottom' : 'top')
                                    }"></div>{{ item.i }}
                                </div>
                            </grid-item>
                        </grid-layout>

                    </div>
                </div>

            </b-col>

            <!-- Vista previa de la etiqueta -->
            <PreviewDesign :dataToShow="generatedHtml"
                :width="`${getDesignWidth}cm`" :sections="getAvailableSections" />

        </b-row>
    </section>
</template>

<script>

// Generales
import { mapState, mapGetters, mapMutations } from 'vuex';

// Componentes
import { GridLayout, GridItem } from "vue-grid-layout"
import FormToSaveDesign from '@/views/labelDesigner/fragments/Form.vue';
import DesignBar from '@/views/labelDesigner/fragments/DesignBar.vue';
import PreviewDesign from '@/views/labelDesigner/fragments/PreviewDesign.vue';

// Mixins
import { IsBlockDesignFormMixin } from '@/servicios/labelDesigner/mixins/IsBlockDesignFormMixin';

export default {

    components: {
        GridLayout,
        GridItem,
        FormToSaveDesign,
        DesignBar,
        PreviewDesign
    },

    mixins: [IsBlockDesignFormMixin],

    data() {
        return {
            designerPlaneRef: null,
            gridWidthFinalCm: 0,
            gridHeightFinalCm: 0,

            eventLog: []
        };
    },

    watch: {

        activeTab(next, prev) {
            if (next && prev !== next && next === 2) {
                this.calculateDivisions();
            }
        },

        selectedLayout(next, prev) {
            if (next && prev !== next) {
                this.calculateDivisions();
            }
        },

        'selectedLayout.gridWidthCm'(next, prev) {
            if (next && prev !== next) {
                this.calculateDivisions();

                this.gridWidthFinalCm = parseFloat(next) + 1
            }
        },

        'selectedLayout.gridHeightCm'(next, prev) {            
            if (next && prev !== next) this.gridHeightFinalCm = parseFloat(next)
        }
        
    },

    computed: {

        ...mapState('labelDesigner', [
            'selectedLayout',
            'availableBaseSections',
            'availableSections',
            'activeSection',
            'activeTab',
            'cursorX',
            'cursorY',
            'showCross',
            'cmToPx',
            'dpi',
            'divisionsX',
            'divisionsY',
            'idRandom',
            'border',
            'isShowingForm'
        ]),

        sectionSelected: {
            get() {
                return this.$store.state.labelDesigner.sectionSelected;
            },
            set(value) {
                this.setSectionSelected(value);
            }
        },

        ...mapGetters('labelDesigner', [
            'layoutWithCm',
            'totalRows',
        ]),

        ...mapState('empresa', {
            personalizedFields: 'listadoCamposPersonalizados'
        }),

        getAvailableSections() {

            if (!this.availableSections || typeof this.availableSections !== 'object') return []
        
            let sections = [
                {
                    label: 'Secciones básicas',
                    options: this.availableBaseSections.map(x => ({ ...x, value: x.id, label: x.title }))
                }
            ]

            Object.entries(this.availableSections).map(([key, section]) => {
                sections.push({
                    label: key,
                    options: section.map(x => ({ ...x, value: x.id, label: x.title }))
                })
            })
            
            
            let optionsToPersonalizedFields = [];
            try {
                
                optionsToPersonalizedFields = this.personalizedFields
                    .map(x => ({ 
                        ...x, 
                        value: `personalizedField-${x.id}`, 
                        label: x.nombre, 
                        code: `personalizedField-${x.id}`,
                        type: "PERSONALIZED_FIELD", 
                        title: x.nombre 
                    }))
                    .filter(x => x.activo === 1)

            } catch (e) {
                optionsToPersonalizedFields = []
            }
            
            sections.push({
                label: 'Campos personalizados',
                options: optionsToPersonalizedFields
            })
            
            return sections

        },

        generatedHtml() {
            let html = `<div style="width: ${this.selectedLayout.gridWidthCm}cm; height: ${this.selectedLayout.gridHeightCm}cm; position: relative; box-sizing: border-box;">`;

            this.layoutWithCm.forEach(x => {

                let item = x;
                if (!('isEditableContent' in item)) {
                    item.isEditableContent = 0; 
                }

                const responseStyles = this.getStylesToItem(item)

                if (!item.borderWidth || item.borderWidth == "undefined") item.borderWidth = '0.75px'
                if (!item.borderStyle || item.borderStyle == "undefined") item.borderStyle = 'solid'
                if (!item.borderColor || item.borderColor == "undefined") item.borderColor = 'black'

                html += `<div template_type="${item.type}" template_code="${item.code}" template="${item.i}" 
                    text_content="${this.getTemplateTextContent(item)}" 
                    join_text="${(item.joinText && item.joinText !== null && item.joinText !== undefined) ? 1 : 0}" 
                    is_editable_content="${item.isEditableContent ? 1 : 0}" id_field="${item.id}"
                    style="${responseStyles.styles}; box-sizing: border-box;" w-value="${responseStyles.width}" h-value="${responseStyles.height}" >
                    <div style="box-sizing: border-box; display: ${item.isShowingContent ? 'flex;' : 'none;'}"></div>
                </div>`;
            });

            html += `</div>`;
            return html;
        },

        gridStyle() {
            return {
                width: (this.gridWidthFinalCm ) * this.cmToPx + 'px',
                height: (this.gridHeightFinalCm ) * this.cmToPx + 'px',
                background: '#f2f2f2',
                marginTop: '0px',
                marginLeft: '0px'
            }
        },

        colNum() {
            return parseFloat(this.selectedLayout.gridWidthCm - 2 * 0)
        },

        rowHeight() {
            return this.cmToPx / 2; // cada fila = 0.5cm de alto
        },

        getDesignWidth() {
            const width = parseFloat(parseFloat(this.selectedLayout.gridWidthCm) + 2);
            return width <= 10 ? 15 : width;
        }

    },

    async mounted() {

        this.gridWidthFinalCm = this.selectedLayout.gridWidthCm
        this.gridHeightFinalCm = this.selectedLayout.gridHeightCm
        
        window.addEventListener('keydown', this.globalKeyHandler);
        window.addEventListener('resize', this.calculateDivisions);

        this.calculateDivisions();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.calculateDivisions);
    },

    methods: {

        ...mapMutations('labelDesigner', [
            'setSelectedLayout',
            'setActiveSection',
            'setActiveTab',
            'resetSelectedLayout',
            'setCursorX',
            'setCursorY',
            'setShowCross',
            'setShowCursorPosition',
            'setDivisionsX',
            'setDivisionsY',
            'setIdRandom',
            'setSectionSelected',
            'setIsShowingPreviewDesign'
        ]),

        getStylesBorder(item) {
            const baseStyles = `${item.borderStyle} ${item.borderColor}`;

            if (item.borderWidth == '0.25pt' || item.borderWidth == '0.5pt') item.borderWidth = '0.75px'

            let borderConfig = [];
            if (item.borderPositions && typeof item.borderPositions === 'object') {
                item.borderPositions.map(bp => {

                    const b = this.border.positions.find(x => x.value === bp)
                    if (b) {

                        switch (b.value) {
                            case 'border':
                                borderConfig.push({ key: 'border', value: `${item.borderWidth} ${baseStyles};`  });
                                break;
                            case 'border-top':
                                borderConfig.push({ key: 'border-top', value: `${item.borderWidth} ${baseStyles};`  });
                                break;
                            case 'border-bottom':
                                borderConfig.push({ key: 'border-bottom', value: `${item.borderWidth} ${baseStyles};`  });
                                break;
                            case 'border-left':
                                borderConfig.push({ key: 'border-left', value: `${item.borderWidth} ${baseStyles};`  });
                                break;
                            case 'border-right':
                                borderConfig.push({ key: 'border-right', value: `${item.borderWidth} ${baseStyles};`  });
                                break;
                            case 'border-x':
                                borderConfig.push({ key: 'border-left', value: `${item.borderWidth} ${baseStyles}; border-right: ${item.borderWidth} ${baseStyles};`  });
                                break;
                            case 'border-y':
                                borderConfig.push({ key: 'border-top', value: `${item.borderWidth} ${baseStyles}; border-bottom: ${item.borderWidth} ${baseStyles};`  });
                                break;
                        }
                    }

                })
            }

            if (!borderConfig) borderConfig = [{ key: `border`, value: '0px;' }];

            return borderConfig
        },

        getStylesToItem(item) {
            let margin = 0
            let top = item.y + 0;
            top = 20 * item.y + (0 * (item.y - 1));
            let height = item.h - 2 * margin;
            let width = (item.w - 2 * margin) / 2;
            height = 20 * item.h + (0 * (item.h - 1));
            
            let baseStyles = `
                position: absolute;
                top: ${top}px;
                left: ${(item.x/2) + margin}cm;
                width: ${width}cm;
                height: ${height}px;                
                text-align: ${item.textAlign};
                box-sizing: border-box;
                min-font-size: ${item.minFontSize ? item.minFontSize : (item.fontSize ? item.fontSize : 3)}px;
                font-size: ${item.fontSize}px;
                max-font-size: ${item.maxFontSize ? item.maxFontSize : item.fontSize}px;
                ${item.code === 'TRANSPORTE' ? 'size-image: 100%;' : `size-image: ${item.sizeImage}cm;`}
                font-weight: ${item.fontWeight};
                text-decoration: ${item.textDecoration};
                color: ${item.fontColor};
                background: ${item.backgroundColor};                
                display: flex;
                justify-content: ${item.justifyContent};
                align-items: ${item.alignItems};
                line-height: normal;
                overflow: hidden;
            `;

            // Estilos para las tablas
            if (item.code === 'TABLE_COMPONENTS') {
                baseStyles += `
                    padding: 0px;
                    table-header-color: ${item.tableHeaderColor};
                    table-header-bg-color: ${item.tableHeaderBgColor};
                    table-body-color: ${item.tableBodyColor};
                    table-body-bg-color: ${item.tableBodyBgColor};
                    table-border-style: ${item.tableBorderStyle};
                    table-border-color: ${item.tableBorderColor};
                    table-border-width: ${item.tableBorderWidth};
                `
            }
            else baseStyles += `padding: 1px;`

            const bordersStyles = this.getStylesBorder(item, false);
            bordersStyles.map(b => baseStyles += `${b.key}: ${b.value}`)

            return { styles: baseStyles.trim(), width, height };
        },

        getStylesToItemGrid(item) {
            let styles = {
                boxSizing: 'border-box',                
                minFontSize: `${item.minFontSize ? item.minFontSize : (item.fontSize ? item.fontSize : 3)}px`,
                maxFontSize: `${item.maxFontSize ? item.maxFontSize : item.fontSize}px`,
                fontSize: `${ (item.maxFontSize && item.maxFontSize < item.fontSize) ? item.maxFontSize : item.fontSize }px`,
                sizeImage: item.code === 'TRANSPORTE' ? '100%' : `${item.sizeImage}cm`,
                fontWeight: item.fontWeight,
                textDecoration: item.textDecoration,
                color: item.fontColor,
                backgroundColor: item.backgroundColor,
                padding: '1px',
                margin: 0,
                gap: 0,
                display: 'flex',
                justifyContent: item.justifyContent,
                alignItems: item.alignItems,            
            };
            
            // Combinar bordes de forma directa
            const borderStyles = this.getStylesBorderToItemGird(item);
            Object.assign(styles, borderStyles);

            return styles
        },

        getStylesBorderToItemGird(item) {
            const styles = {};

            if (!item.borderStyle || !item.borderColor) return styles;

            const baseStyle = `${item.borderWidth === '0.25pt' || item.borderWidth === '0.5pt' ? '0.75px' : item.borderWidth} ${item.borderStyle} ${item.borderColor}`;

            if (item.borderPositions && Array.isArray(item.borderPositions)) {
                for (const bp of item.borderPositions) {
                    switch (bp) {
                        case 'border':
                            styles.border = baseStyle;
                            break;
                        case 'border-top':
                            styles.borderTop = baseStyle;
                            break;
                        case 'border-bottom':
                            styles.borderBottom = baseStyle;
                            break;
                        case 'border-left':
                            styles.borderLeft = baseStyle;
                            break;
                        case 'border-right':
                            styles.borderRight = baseStyle;
                            break;
                        case 'border-x':
                            styles.borderLeft = baseStyle;
                            styles.borderRight = baseStyle;
                            break;
                        case 'border-y':
                            styles.borderTop = baseStyle;
                            styles.borderBottom = baseStyle;
                            break;
                        default:
                            break;
                    }
                }
            }

            return styles;
        },

        getTemplateTextContent(item) {            
            if (item.text_content && item.textContent !== null && item.textContent !== undefined) {
                return item.textContent;
            }

            else if (item.isShowingContent) {
                return item.textContent;
            }

            return '';
        },

        calculateDivisions() {
            const container = this.$el;
            const width = container.clientWidth - 20;
            const height = container.clientHeight - 20;

            // Divisiones horizontales (Regla Superior)
            this.setDivisionsX(Array.from(
                { length: Math.floor(width / (this.cmToPx / 10)) },
                (_, i) => i * (this.cmToPx / 10)
            ));

            // Divisiones verticales (Regla Izquierda)
            this.setDivisionsY(Array.from(
                { length: Math.floor(height / (this.cmToPx /10)) },
                (_, i) => i * (this.cmToPx /10)
            ));
        },

        onHandleShowPreviewer() {
            this.setIsShowingPreviewDesign(true)
        },

        handleMouseMove(event) {
            const containerRect = event.currentTarget.getBoundingClientRect();
            this.setCursorX(event.clientX - containerRect.left);
            this.setCursorY(event.clientY - containerRect.top);
            this.setShowCross(true);

            // Mostrar solo si está dentro del contenedor
            this.setShowCursorPosition(
                this.cursorX > 0 &&
                this.cursorX < containerRect.width &&
                this.cursorY > 0 &&
                this.cursorY < containerRect.height
            )
        },

        hideCross() {
            this.setShowCross(false);
            this.setShowCursorPosition(false);
        },

        onHandleAddSection(sectionCode) {

            this.setSectionSelected(sectionCode)

            let section = null
            this.getAvailableSections.map(x => {
                
                const find = x.options.find(o => {
                    const idCode = o.type === 'PERSONALIZED_FIELD' ? `personalizedField-${o.id}` : o.id
                    if (idCode === sectionCode) return o 
                })
                if (find) section = find
                
            });

            if (!section) {
                this.$alertError('Seleccione una sección', 4000, true, 'Diseñador de etiquetas', 'warning');
                this.setSectionSelected(null)
                return
            }

            const baseDataSection = {
                "x": 2,
                "y": 2,
                "w": 2,
                "h": 2,
                "i": section.title,
                "baseTitle": section.title,
                "minFontSize": 3,
                "fontSize": 12,
                "maxFontSize": 12,
                "fontColor": this.isEditableSections(section) ? '#FFFFFF' : "#000000",
                "backgroundColor": this.isEditableSections(section) ? '#097b83' : "#FFFFFF",
                "border": '0.75px solid black',
                "id": this.idRandom,
                "code": section.code,
                "type": section.type,
                "text_content": null,
                "join_text": 0,
                "borderPositions": ['border'],
                "borderWidth": '0.75px',
                "borderColor": 'black',
                'borderStyle': 'solid',
                "isEditableContent": 0,
                "isShowingContent": 0,
            }

            let cloneSection = this.selectedLayout.layout.length > 0 ? this.selectedLayout.layout[this.selectedLayout.layout.length - 1] : null;
            let newSection = cloneSection ?
                { ...baseDataSection, x: cloneSection.x + 1, y: cloneSection.y + 1, w: 15, h: 2 } :
                baseDataSection;

            const findEqual = this.selectedLayout.layout.filter(i => (i.baseTitle === newSection.baseTitle) && (
                'TEXT' === newSection.code || 'CLEAR_BOX' === newSection.code
            ));
            if (findEqual.length > 0) {
                newSection.i = `${newSection.i} (${findEqual.length + 1})`;
            } if (this.selectedLayout.layout.find(i => i.i === newSection.i)) {
                this.$alertError('Ya existe la sección en el diseñador de Etiquetas', 5000, true, 'Diseñador de etiquetas', 'info');
                this.setSectionSelected(null);
                return
            }

            this.setSelectedLayout({
                ...this.selectedLayout,
                layout: [...this.selectedLayout.layout, newSection]
            });

            this.setIdRandom(Math.random());
            this.setActiveSection(newSection);
            this.setSectionSelected(null)
        },

        isEditableSections(section) {
            return section.code === 'TEXT'
        },

        onHandleCancelDesign() {
            this.resetSelectedLayout()
            this.setActiveSection(null)
            this.setActiveTab(1)
        },

        onHandleActionToSection(item) {
            this.$bvToast.hide('show-options-border')
            this.$bvToast.hide('show-edit-content-title')
            this.setActiveSection(item);
        },

        globalKeyHandler(e) {
            if (!this.activeSection) return

            if (e.key === 'Delete') {
                this.$refs.designBarRef.removeItem()
            }
        }

    }
};
</script>

<style scoped>
.container-draw {
    position: relative;
    width: 100vw;
    height: 100vh;
    border: 1px solid #ccc;
    overflow: hidden;
    background: #fff;
}

/* Esquina superior izquierda (espacio vacío) */
.ruler-corner {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    background: white;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    z-index: 2;
}

/* Regla Superior */
.ruler-top {
    position: absolute;
    top: 0;
    left: 20px;
    width: calc(100% - 20px);
    height: 20px;
    border-bottom: 0px solid #ccc;
}

/* Regla Izquierda */
.ruler-left {
    position: absolute;
    top: 20px;
    left: 0;
    width: 20px;
    height: calc(100% - 20px);
    border-right: 0px solid #ccc;
}

/* Líneas en la regla */
.ruler-line {
    position: absolute;
    background: black;
}

/* Líneas en la regla superior */
.ruler-top .ruler-line {
    width: 1px;
}

.cm {
    height: 10px;
}

.half-cm {
    height: 7px;
}

.mm {
    height: 5px;
}

/* Líneas en la regla izquierda */
.ruler-left .ruler-line {
    height: 1px;
}

.ruler-left .cm {
    width: 9px;
}

.ruler-left .half-cm {
    width: 7px;
}

.ruler-left .mm {
    width: 4px;
}

/* Alineación de los números en la regla superior */
.ruler-top .ruler-line span {
    position: absolute;
    top: 8px;
    left: -3px;
    font-size: 8px;
    color: black;
}

/* Alineación de los números en la regla izquierda */
.ruler-left .ruler-line span {
    position: absolute;
    left: 9px;
    top: -5px;
    font-size: 8px;
    color: black;
}

/* Líneas del cursor */
.cross-line {
    position: absolute;
    background: #c2c2c2;
    pointer-events: none;
}

.cross-line.vertical {
    width: 1px;
    height: 100%;
}

.cross-line.horizontal {
    width: 100%;
    height: 1px;
}

/* Indicador de posición en cm en la parte inferior */
.cursor-info {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: right;
    padding: 5px 10px;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.05);
    border-top: 1px solid #ccc;
    color: #333;
    box-sizing: border-box;
    pointer-events: none;
}

.el-input__inner {
    background-color: #ffffff00;
}

/* Estilos para elementos con movimiento bloqueado */
.blocked-movement {
    cursor: pointer !important;
    opacity: 0.8;
}

.blocked-movement:hover {
    opacity: 0.9;
}
</style>
